import { Tab, Tabs, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { AppRoutesNavigation } from 'src/app-routes'
import { IProjectStatus } from 'src/generated-types/project-status'
import { useProjectCtx } from 'src/hooks/context-hooks'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { ProjectTab } from 'src/enums/project-tab'
import { getActiveProjectTab } from './ProjectTabs.action'

// Post-publish tools live beside Positions. Hidden until the project is published and linked to its mooring.
export const ProjectTabs = () => {
  const { t: translate } = useTranslation(['projects'])
  const { selectedProject } = useProjectCtx()
  const { customerId, localityId, projectId } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const isPublished = selectedProject?.status === IProjectStatus.Published
  if (!isPublished || !selectedProject?.publishedMooringId || !selectedProject?.mooringPermission) return null

  const ids = [customerId as EntityId, localityId as EntityId, projectId as EntityId] as const
  const pathOf: Record<ProjectTab, string> = {
    positions: AppRoutesNavigation.Project.project(...ids),
    'work-assignments': AppRoutesNavigation.Project.workAssignments(...ids),
    'batch-numbers': AppRoutesNavigation.Project.batchNumbers(...ids),
  }

  return (
    <StyledTabs
      value={getActiveProjectTab(pathname)}
      onChange={(_, tab: ProjectTab) => navigate(pathOf[tab])}
      textColor="inherit"
      indicatorColor="primary"
    >
      <Tab value="positions" label={translate('tab-positions', { ns: 'projects' })} />
      <Tab value="work-assignments" label={translate('tab-work-assignments', { ns: 'projects' })} />
      <Tab value="batch-numbers" label={translate('tab-batch-numbers', { ns: 'projects' })} />
    </StyledTabs>
  )
}

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 40,
  borderBottom: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  '& .MuiTab-root': {
    color: theme.palette.text.primary,
    opacity: 0.7,
    minHeight: 40,
    textTransform: 'none',
    fontWeight: 500,
    '&.Mui-selected': {
      color: getThemeColor(theme, MUIThemeColors.primaryMain),
      opacity: 1,
    },
  },
}))

export default ProjectTabs
